/*
 * Copyright (c) 2019 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

import React from "react";
import { Helmet } from "react-helmet";
import { t } from "./i18n/i18n";
import { Subscribe } from "unstated";
import { Switch } from "react-router";
import { AppState } from "app-state/AppState";
import Header from "components/base/Header/Header";
import Footer from "components/base/Footer/Footer";
import ErrorRoutes from "routes/ErrorRoutes";
import AppRoute from "./routes/AppRoute";
import { isInLauncher } from "./launcher-bindings/launcherWebviewClient";
import { GoogleTagManagerInit } from "components/gtmInit";

import "./styles";

export default class App extends React.Component {
  componentDidMount(): void {
    import("./app-tasks")
      .then((module) => module.default)
      .then((taskRunner) => taskRunner());
  }

  render() {
    return (
      <Subscribe to={[AppState]}>
        {(appState: AppState) => {
          const {
            state: { appHistory },
          } = appState;
          return (
            <div key={appHistory.location.pathname} id="app">
              {process.env.NODE_ENV !== "development" && <GoogleTagManagerInit />}
              <Helmet defaultTitle={t("Common.appName")}>
                <meta charSet="utf-8" />
                <meta name="description" content={t("Common.defaultMetaDescription")} />
              </Helmet>
              {!isInLauncher() && <Header />}
              <div className="container">
                <Switch>
                  {AppRoute()}
                  {ErrorRoutes()}
                </Switch>
              </div>
              {!isInLauncher() && <Footer />}
            </div>
          );
        }}
      </Subscribe>
    );
  }
}
